import Vue from "vue";
import Router from "vue-router";
import APCNavbar from "./layout/APCNavbar.vue";
import APCFooter from "./layout/APCFooter.vue";
import Home from "./pages/Home.vue";
import Offers from "./pages/Offers.vue";
import Reservation from "./pages/Reservation.vue";
import Confirmation from "./pages/Confirmation.vue";
import History from "./pages/History.vue";
import Settings from "./pages/Settings.vue";
import FAQ from "./pages/FAQ.vue";
import PrivacyPolicy from "./pages/PrivacyPolicy.vue";
import CancelationPolicy from "./pages/CancelationPolicy.vue";
import TermsOfService from "./pages/TermsOfService.vue";
import store from "@/store";

Vue.use(Router);

export default new Router({
  mode: "history",
  routes: [
    {
      path: "/",
      name: "/",
      components: { default: Home, header: APCNavbar, footer: APCFooter },
      props: {
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/offers",
      name: "/offers",
      components: { default: Offers, header: APCNavbar, footer: APCFooter },
      props: {
        default: true,
        footer: { backgroundColor: "black" },
      },
      beforeEnter: (to, from, next) => {
        const { airportCode } = to.query;
        if (airportCode) {
          next();
        } else {
          next({ name: "/" });
        }
      },
    },
    {
      path: "/reservation",
      name: "/reservation",
      components: {
        default: Reservation,
        header: APCNavbar,
        footer: APCFooter,
      },
      props: {
        default: true,
        footer: { backgroundColor: "black" },
      },
      beforeEnter: (to, from, next) => {
        const { id } = to.query;
        if (id) {
          next();
        } else {
          next({ name: "/offers" });
        }
      },
    },
    {
      path: "/confirmation",
      name: "/confirmation",
      components: {
        default: Confirmation,
        header: APCNavbar,
        footer: APCFooter,
      },
      props: {
        default: true,
        footer: { backgroundColor: "black" },
      },
      beforeEnter: (to, from, next) => {
        const { data } = to.params;
        if (data) {
          next();
        } else {
          next({ name: "/offers" });
        }
      },
    },
    {
      path: "/history",
      name: "/history",
      components: { default: History, header: APCNavbar, footer: APCFooter },
      props: {
        footer: { backgroundColor: "black" },
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.accessToken) next({ name: "/" });
        else next();
      },
    },
    {
      path: "/settings",
      name: "/settings",
      components: { default: Settings, header: APCNavbar, footer: APCFooter },
      props: {
        footer: { backgroundColor: "black" },
      },
      beforeEnter: (to, from, next) => {
        if (!store.state.accessToken) next({ name: "/" });
        else next();
      },
    },
    {
      path: "/faq",
      name: "/faq",
      components: { default: FAQ, header: APCNavbar, footer: APCFooter },
      props: {
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/privacy-policy",
      name: "/privacy-policy",
      components: {
        default: PrivacyPolicy,
        header: APCNavbar,
        footer: APCFooter,
      },
      props: {
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/cancelation-policy",
      name: "/cancelation-policy",
      components: {
        default: CancelationPolicy,
        header: APCNavbar,
        footer: APCFooter,
      },
      props: {
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "/terms-of-service",
      name: "/terms-of-service",
      components: {
        default: TermsOfService,
        header: APCNavbar,
        footer: APCFooter,
      },
      props: {
        footer: { backgroundColor: "black" },
      },
    },
    {
      path: "*",
      redirect: "/",
    },
  ],
  scrollBehavior: (to, from, savedPosition) => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});
